<template>
  <div>
    <div class="container">
      <h1 class="pb-2 mt-4 mb-2 border-bottom">{{ $t(pageTitle) }}</h1>
      <p>{{ $t('アカウントをお持ちではない場合は「新規登録」ボタンを、既存のアカウントに連携する場合には「アカウント連携」ボタンを押下してください。') }}</p>

      <div class="container-fluid">
        <div class="row justify-content-around text-center">
          <div class="col-3">
            <a :href="signupLocation" class="btn btn-lg btn-light btn-block">{{ $t('新規登録') }}</a>
          </div>
          <div class="col-3">
            <a :href="ediApproveLocation" class="btn btn-lg btn-light btn-block">{{ $t('アカウント連携') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'querystringify'

export default {
  data() {
    return {
      pageTitle: 'スケジューラシリーズ 連携登録',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    const query = qs.parse(location.search)
    if (!query.edi_token) {
      window.location.href = this.$appConfig.ScreenUrl.login
    }
  },
  computed: {
    signupLocation() {
      return this.$appConfig.ScreenUrl.signup + location.search
    },
    ediApproveLocation() {
      return this.$appConfig.ScreenUrl.ediApprove + location.search
    },
  },
}
</script>
